import type { ReactNode } from "react";
import { AuthBrandHeader } from "./AuthBrandHeader";

export interface AuthCardProps {
  title: string;
  subtitle?: ReactNode;
  children: ReactNode;
  /** Optional footer row (e.g. a link to another auth route). */
  footer?: ReactNode;
}

/**
 * Card layout shared by the portals' unauthenticated routes: `AuthBrandHeader`
 * above the card, both centered on `bg-mist`.
 */
export function AuthCard({ title, subtitle, children, footer }: AuthCardProps): ReactNode {
  return (
    <div className="bg-mist flex min-h-screen items-center justify-center px-6 py-12">
      <div className="max-w-120 w-full">
        <AuthBrandHeader />
        <div className="border-haze rounded-3xl border-2 bg-white p-10 shadow-sm">
          <h1 className="text-h2 text-midnight font-serif">{title}</h1>
          {subtitle && <p className="text-slate-teal text-body-lg mt-2">{subtitle}</p>}
          <div className="mt-4">{children}</div>
        </div>
        {footer && <div className="text-slate-teal text-body-sm mt-8 text-center">{footer}</div>}
      </div>
    </div>
  );
}
